import { Box, FormLabel, Link } from "@mui/material";
import GA4React from "ga-4-react";
import React from "react";
import { ResourceSectionInfo } from "../../shared/models/ResourceSectionInfo";
import { useEffect, useState } from "react";
import useWindowDimensions from "../../shared/windowDimensions";

import styles from "./resources.module.scss";

type ResourcesProps = {
  ga4react: GA4React;
  isMobileDevice: boolean;
};

const Resources = ({ ga4react, isMobileDevice }: ResourcesProps) => {
  const [pageContentHeight, setPageContentHeight] = useState("");
  const [resourcesList, setResourcesList] = useState([] as ResourceSectionInfo[]);
  const { screenHeight, screenWidth } = useWindowDimensions();

  useEffect(() => {
    getResources();
  }, []);

  useEffect(() => {
    setPageContentHeight(
      isMobileDevice
        ? `calc(${screenHeight}px - 228px)`
        : `calc(${screenHeight}px - 376px)`
    );
  }, [isMobileDevice, screenHeight]);

   const getResources = async () => {
    try {
      // Get the list of resources via the json file
      var response = await fetch(
        "https://cornbreadkids.com/CornbreadKids/api/ResourceSections"
      );
      var resources = await response.json();
      setResourcesList(resources);
      } catch (error) {
        console.error(error);
        return [];
      }
    };

  return (
    <Box
      bgcolor="#CCCCCC"
      className={styles.pageContent}
      style={{
        height: pageContentHeight,
        justifyContent: "center",
        margin: "0 10px 10px 10px",
        padding: "10px 0",
      }}
      sx={{
        "&::-webkit-scrollbar": {
          width: "15px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#666666",
          borderRadius: 2,
        },
      }}
    >
      <Box
        bgcolor="white"
        borderRadius="7px"
        display="flex"
        flexDirection="column"
        margin="10px auto 10px auto"
        padding="10px 10px 30px 10px"
        sx={{ overflowX: "hidden" }}
        width="80%"
      >
        <Box
          sx={{
            color: "black",
            flexGrow: "1", 
            fontSize: "28px",
            fontWeight: "bold",
            margin: "30px auto 5px auto",
            overflow: "auto",
        }}
        >
          {resourcesList.map((resourceSection) => (
            <React.Fragment key={resourceSection.Id}>
              <FormLabel
                sx={{
                  alignItems: "center",
                  color: "black",
                  display: "flex",
                  fontSize: "28px",
                  fontWeight: "bold",
                  justifyContent: "center",
                  margin: "auto",
                }}
              >
                {resourceSection.Name}
              </FormLabel>
              <Box
                sx={{
                  fontSize: isMobileDevice ? "20px" : "24px",
                  margin: "20px auto",
                }}
              >
                {resourceSection.Resources.map((resource) => (
                  <Box sx={{ display: "block", marginBottom: "10px" }} key={resource.Id}>
                    <Link
                      href={resource.Link}
                      target="_blank"
                      rel="noreferrer"
                      underline="none"
                      onClick={() =>
                        ga4react.event(
                          "Puzzle Download Clicked",
                          resource.Name,
                          "Click",
                          false
                        )
                      }
                    >
                      {resource.Name}
                    </Link>
                  </Box>
                ))}
              </Box>
            </React.Fragment>
          ))}
        </Box>       
      </Box>  
    </Box>
  );
};

export default Resources;
